<template>
    <div class="avatar-image" v-fs-block>
        <div class="avatar-initials" :class="['avatar-initials-' + initialsColor]">
            <span>{{initials}}</span>
        </div>
    </div>
</template>

<script>
    const colors = ['gray', 'yellow', 'green', 'accent', 'dark-background'];
    export default {
        name: 'v-avatar',
        props: {
            initials: String,
        },
        computed: {
            initialsColor() {
                const totalCharValue = this.initials
                    .split('')
                    .reduce((sum, char) => sum + char.charCodeAt(0), 0);
                return colors[totalCharValue % colors.length];
            },
        },
    };
</script>
